module.exports = __webpack_public_path__ + "img/history_timeline_6.311d887b.png";